/**
 * Created by danielr on 2/27/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/twilio/twilioActivationView.tmpl");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Button = require("ui/button/Button");
    var KpContent = require("ui.components/kpContent/kpContent");
    var InputField = require("ui/input-field/InputField");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");

    var TwilioActivationView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        TwilioActivationView = Marionette.ItemView.extend({
            template : template,
            className : "app-install-edit-container-view conversation-source-edit-activation-container twilio-activation-container",
            ui : {
                activation: ".toggle-container",
                cancelButton: ".button-cancel",
                backButton: ".button-back",
                nextButton: ".button-next",
                nameInputContainer: ".app-install-name-container .input-container",
                learnMore: ".learn-more",
                progressBar: ".conversation-source-edit-progress-bar",
                twilioLogoUriInputContainer: ".app-install-logo-uri-container .input-container"
            },
            uiComponents : {
                appInstallIconUrl:{
                    type: InputField,
                    options: {
                        el: "view.ui.twilioLogoUriInputContainer",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        value: "view._getTwilioLogoName"
                    }
                },
                learnMoreButton:{
                    type: KpContent,
                    options: {
                        container: "view.ui.learnMore",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "view._getLearnMoreKpId",
                        showKPIcon: true
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                },
                backButton:{
                    type: Button,
                    options: {
                        el: "view.ui.backButton",
                        permutation: Button.PERMUTATION.BTN,
                        initState: Button.STATES.DISABLED
                    }
                },
                nextButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nextButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_onNextClick"
                    }
                },
                activation: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.activation",
                        transition: ToggleButton.TRANSITION.FAST,
                        checked: "view._getSourceEnableStatus",
                        tooltip: {
                            active: "",
                            inactive: LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.toggle.inactive.tooltip")
                        }
                    },
                    events: {
                        "toggleButton:change": "_onActivateChange"
                    }
                },
                sourceName:{
                    type: InputField,
                    options:{
                        el:"view.ui.nameInputContainer",
                        readonly: true,
                        permutation: InputField.Permutation.B,
                        value: LE.translator.translate("LEManager.dataSources.conversationSources.gallery.twilio.name")
                    }
                },
                progressBar: {
                    type: StepIndicator,
                    options: {
                        el: "view.ui.progressBar",
                        permutation: StepIndicator.PERMUTATION.G,
                        steps: [
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.stepName"), state: StepIndicator.STATE.CURRENT},
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.config.stepName"), state: "view._getConfigStepComplete"}
                        ]
                    }
                }
            },
            initialize : function (options) {
                LEManager.logger.debug("TwilioActivationView:initialize");
                this.channel = LEManager.media.channel("conversationSources");
                this.typeConfiguration = this.model.getTypeConfiguration();
                this._bindEvents();
            },
            customTemplateHelpers: function() {
                var videoUrl = this.typeConfiguration.video;
                var showVideo = !_.isEmpty(videoUrl);
                var logo_uri = this.typeConfiguration.logo_uri;
                var instructions = [
                    { instruction: LE.translator.translate("LEManager.dataSources.conversationSources.twilio.header.advantage1")},
                    { instruction: LE.translator.translate("LEManager.dataSources.conversationSources.twilio.header.advantage2")},
                    { instruction: LE.translator.translate("LEManager.dataSources.conversationSources.twilio.header.advantage3")}
                ];
                var description = this._getLongDescription();
                return {
                    showVideo: showVideo,
                    videoUrl: videoUrl,
                    instructions: instructions,
                    logo_uri: logo_uri,
                    description: description
                };
            },
            _bindEvents: function(){
                this.listenTo(this, "page:closeButtonClick", this._onCancelClick);
            },
            _getTwilioLogoName: function() {
                var logoUrl = this.typeConfiguration.logo_uri;
                var logoUrlSplit = logoUrl.split("/");
                return logoUrlSplit[logoUrlSplit.length - 1];
            },
            _getSourceEnableStatus: function(){
                return this.model.getEnabled();
            },
            _onActivateChange: function(componentId, eventName, value){
                this.model.setEnabled(value);
            },
            _onCancelClick: function(){
                this.channel.trigger("twilio:activation:cancel");
            },
            _onNextClick: function(){
                this.channel.trigger("twilio:activation:next");
            },
            _getConfigStepComplete: function(){
                return this.model.isConfigStepComplete() ? StepIndicator.STATE.COMPLETED : StepIndicator.STATE.NOT_COMPLETED;
            },
            _getLearnMoreKpId: function() {
                return this.typeConfiguration.kp;
            },
            _getLongDescription: function() {
                return LE.translator.translate("LEManager.dataSources.conversationSources.gallery.twilio.description.full");
            },
            onClose : function () {
                LEManager.logger.debug("TwilioActivationView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return TwilioActivationView;
});
